import { call, put, takeLatest } from 'redux-saga/effects';
import {
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO,
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING,
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,
} from '../../actionTypes';
import { conciliacaoBancariaService } from '../../service';
import { AlertError } from '@components/common/AlertToast';

function* sagaNewFilterLancamentosBanco(action) {
  try {
    yield put({ type: NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING });

    const { contaBancoId, dataInicio, dataFim, tipoMovimento, page = 0, size = 10, historico } = action.args || action;

    const response = yield call(
      conciliacaoBancariaService.buscarLancamentosBancoPendentes,
      contaBancoId,
      dataInicio,
      dataFim,
      page,
      size,
      tipoMovimento,
      historico
    );

    yield put({
      type: NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
      response: response.data || response,
      args: { contaBancoId, dataInicio, dataFim, tipoMovimento, page, rows: size, historico }
    });

  } catch (error) {
    yield put({
      type: NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,
      error: error.message || 'Erro ao buscar lançamentos banco'
    });

    const errorMessage = error.response?.data?.message || error.message || 'Erro ao buscar lançamentos banco';
    AlertError(errorMessage);
  }
}

export default function* watchNewFilterLancamentosBanco() {
  yield takeLatest(NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO, sagaNewFilterLancamentosBanco);
}
